import Text from '@atoms/Text';
import React from 'react';
import texts from "./en.json";
import LazyImage from '@atoms/LazyImage';

export const ProductWhyInvest = ({ productWhyInvest }) => {
    const { title, cards } = productWhyInvest || {};

    const ProductWhyInvestCard = (title, description, icon, index) => {
        return (
            <li key={index} className="flex flex-col items-center justify-center p-3 md:p-6 bg-basicWhite shadow-lg rounded-xl flex-[1_0_0%] md:flex-[1_0_40%] w-full max-w-[350px] xl:flex-[1_0_0%]">
                <LazyImage src={icon} className="mb-3 md:mb-6 h-12 md:h-[60px] relative w-12 md:w-[60px]" />
                <Text
                    content={title}
                    htmlTag="h3"
                    className="mb-1 text-basicBlack p4-semibold text-center"
                />
                <Text
                    content={description}
                    className="text-basicBlack p5-regular text-center mb-4"
                />
            </li>
        );
    };
    return (
        <div id="product-why-invest" className='flex flex-col items-center py-3 px-4 md:pt-9 md:pb-8 xl:pb-6 md:px-6 xl:px-18'>
            <div className='text-center'>
                <Text content={`${texts.whyInvest} `} className="inline text-basicBlack p3-regular md:h3-regular whitespace-pre" htmlTag='h2' />
                <Text content={title} className="inline text-basicBlack p3-semibold md:h3-semibold" htmlTag='h2' />
            </div>
            <ul className="grid grid-cols-1 place-items-center md:flex md:flex-wrap justify-center mt-4 md:mt-8 gap-6 xl:gap-x-8 w-full">
                {cards?.map(({ title, description, icon }, index) =>
                    ProductWhyInvestCard(title, description, icon, index)
                )}
            </ul>
        </div>
    );
};
